const DISCONNECTION_REASON_LABELS = {
  agent_hangup: 'Agent Hangup',
  call_transfer: 'Call Transfer',
  caller_hangup: 'Caller Hangup',
  user_hangup: 'User Hangup',
};

const normalizeDisconnectionReasonKey = (value) => String(value || '')
  .trim()
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, '_')
  .replace(/^_+|_+$/g, '');

const titleizeDisconnectionReason = (value) => String(value || '')
  .trim()
  .replace(/[_-]+/g, ' ')
  .replace(/\s+/g, ' ')
  .replace(/\b\w/g, (letter) => letter.toUpperCase());

const formatDisconnectionReason = (callLogOrReason) => {
  const reason = typeof callLogOrReason === 'object'
    ? callLogOrReason
    : { disconnection_reason: callLogOrReason };
  const rawValue = reason?.disconnection_reason_label || reason?.disconnection_reason;
  const key = reason?.disconnection_reason_key || normalizeDisconnectionReasonKey(rawValue);

  if (!rawValue || String(rawValue).trim() === '') return '';

  return DISCONNECTION_REASON_LABELS[key] || titleizeDisconnectionReason(rawValue);
};

export {
  DISCONNECTION_REASON_LABELS,
  formatDisconnectionReason,
  normalizeDisconnectionReasonKey,
};
